module.exports = __webpack_public_path__ + "img/schedule20261212_2.825d61fc.jpg";